/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import * as actionTypes from "./actionTypes";
import { axiosSA } from "../../axios";
import moment from "moment";
import { processVehiclesData } from "../../shared/vehicles";
import { setToken } from "./index";
import { convertDevicesV1toV0 } from "../../shared/helper";

// fetch vehicles
export const fetchVehicles = () => {
  return async (dispatch, getState) => {
    // startDateTime and endDateTime according to visit window
    let startDateTime = moment().utc().format("YYYY-MM-DDTHH:mm:ss") + "Z";
    let endDateTime =
      moment().utc().add(12, "hours").format("YYYY-MM-DDTHH:mm:ss") + "Z";

    // refresh idToken if expired
    let token = await dispatch(setToken());

    axiosSA
      .get(`/equipments/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          startDateTime,
          endDateTime,
          pageSize: 100,
        },
      })
      .then((res) => {
        dispatch(
          setVehicles(processVehiclesData(convertDevicesV1toV0(res.data)))
        );
      })
      .catch((err) => {
        // console.log("vehicles error", err.response);
      });
  };
};

// set vehicle data in redux store
const setVehicles = (info) => {
  return {
    type: actionTypes.SET_VEHICLE,
    usersVehiclesInfo: info,
  };
};
